import Image from "next/image";
import React from 'react'
import styles from "./tnpsc-group-iv-test-batch.module.css";
import Banner from "../../assets/images/Tnpsc/TNPSC-GR-IV-Web-Banner.jpg";
import MobBanner from "../../assets/images/Tnpsc/TNPSC-GR-IV-Mobile-Banner.jpg";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Link from 'next/link';
import Head from 'next/head';

const Tnpsc_gr_IV_testbatch = () => {

    const feestructure3 =[

        {center:"AnnaNagar",mode:( <> <div>Batch IV Weekend  <br/>(Offline Only )</div> </>),start:"15th Mar 2025", 
            fee: ( <> <div>₹5,000 (New students )</div>  <div>₹4,000 ( Old Students)</div> <div>₹5,000 ( Online For All Students)</div></>), 
          cont3:<Link href="/pdf/TNPSC-GRPIV-2025/Anna-Nagar/TNPSC-GRP-IV-Annanagar-B4-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},

        {center:"AnnaNagar",mode:"Batch III Regular (Offline/Online)",start:"26th Feb 2025", 
            fee: ( <> <div>₹5,000 (New students )</div>  <div>₹4,000 ( Old Students)</div> <div>₹4,500 ( Online For All Students)</div></>), 
          cont3:<Link href="/pdf/TNPSC-GRPIV-2025/Anna-Nagar/TNPSC-GRP-IV-Annanagar-B3-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},
        
        
        {center:"Trichy",mode:( <> <div>Batch II Weekend<br/>(Offline Only)</div> </>),start:"22nd Feb 2025", 
            fee: ( <> <div>₹5,500 (For New students )</div>  <div>₹5,000 (For Old Students)</div> </>),    
          cont3:<Link href="/pdf/TNPSC-GRPIV-2025/trichy/Tnpsc-GRPIV-B2-Weekend-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},  

        {center:"Madurai",mode:( <> <div>Batch II Weekend<br/>(Offline Only)</div> </>),start:"01st Mar 2025", 
            fee: ( <> <div>₹5,500 (For New students )</div>  <div>₹5,000 (For Old Students)</div> </>),  
          cont3:<Link href="/pdf/TNPSC-GRPIV-2025/Madurai/Tnpsc-GRPIV-B2-Wknd-Madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},  
        
        {center:"Salem",mode:( <> <div>Batch II Regular<br/>(Offline Only)</div> </>),start:"08th Apr 2025", 
            fee: ( <> <div>₹5,500 (For New students )</div>  <div>₹5,000 (For Old Students)</div> </>),   
          cont3:<Link href="/pdf/TNPSC-GRPIV-2025/salem/TNPSC-GRP-IV-B2-Salem-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},  
        
        {center:"Chennai - Adyar",mode:( <> <div>Batch I Regular <br/>(Offline Only)</div></>),start:"10th Feb 2025", 
            fee: ( <> <div>₹5,500 (For New students )</div>  <div>₹5,000 (For Old Students)</div> </>),     
          cont3:<Link href="/pdf/TNPSC-GRPIV-2025/Adyar/TNPSC-GRPIV-Adyar-B1-UPDATED.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},  

        {center:"Thiruvarur",mode:( <> <div>Batch I Regular<br/>(Offline Only)</div> </>),start:"05th Jan 2025", 
            fee: ( <> <div>₹5,500 (For New students )</div>  <div>₹5,000 (For Old Students)</div> </>),   
          cont3:<Link href="/pdf/TNPSC-GRPIV-2025/Thiruvarur/TNPSC-GRPIV-Thiruvarur-B1-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},  
        
        {center:"Namakkal",mode:( <> <div>Batch I Regular <br/>(Offline Only)</div> </>),start:"09th Jan 2025", 
            fee: ( <> <div>₹5,500 (For New students )</div>  <div>₹5,000 (For Old Students)</div> </>),
          cont3:<Link href="pdf/TNPSC-GRPIV-2025/Namakkal/TNPSC-GRPIV-Namakkal-B1-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},  
        
        {center:"Salem",mode:( <> <div>Batch I Regular<br/>(Offline Only) </div> </>),start:"11th Jan 2025", 
            fee: ( <> <div>₹5,500 (For New students )</div>  <div>₹5,000 (For Old Students)</div> </>),
          cont3:<Link href="/pdf/TNPSC-GRPIV-2025/salem/SIA-2025-TNPSC-GRP-IV _SALEM_BATCH_1_OFFLINE_Revised.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},  
        
        {center:"Trichy",mode:( <> <div>Batch I Regular<br/>(Offline Only)</div> </>),start:"20th Jan 2025", 
            fee: ( <> <div>₹5,500 (For New students )</div>  <div>₹5,000 (For Old Students)</div> </>),    
          cont3:<Link href="/pdf/TNPSC-GRPIV-2025/trichy/SIA-2025-TNPSC-GRIV-TRICHY-BATCH-1-OFFLINE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},  

        {center:"Madurai",mode:( <> <div>Batch I Regular<br/>(Offline Only)</div> </>),start:"22nd Jan 2025", 
            fee: ( <> <div>₹5,500 (For New students )</div>  <div>₹5,000 (For Old Students)</div> </>),  
          cont3:<Link href="/pdf/TNPSC-GRPIV-2025/Madurai/SIA-2025-TNPSC-GRIV-B1-Madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},  
        
        {center:"Coimbatore",mode:( <> <div>Batch I Regular<br/>(Offline Only)</div> </>),start:"01st Jan 2025", 
            fee: ( <> <div>₹5,500 (For New students )</div>  <div>₹5,000 (For Old Students)</div> </>),  
          cont3:<Link href="/pdf/TNPSC-GRPIV-2025/coimbatore/SIA-2025-TNPSC-GRIV-Coimbatore-batch1-OFFLINE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},  
        
        ]  
        

    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            <link rel="icon" href="./logo.png" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Group 4 Test Batch | Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Group 4 Test Batch | Shankar IAS Academy" />
            <meta name="description" content="Shankar IAS Academy's TNPSC Group 4 Test Batch: Elevate your preparation with expert coaching and proven strategies. Get success in Group 4 exams!" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-iv-test-batch/ " />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group 4 Test Batch | Shankar IAS Academy" />
            <meta property="og:description" content="Shankar IAS Academy's TNPSC Group 4 Test Batch: Elevate your preparation with expert coaching and proven strategies. Get success in Group 4 exams!" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-iv-test-batch/ " />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

            <Navbar title="tnpsc" />

            <div className="container">
                <div className="pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>TNPSC Group IV Test Batch 2025</h1>
                </div>
            </div>

        <div className="container pb-4">

            <div className="row d-none d-md-block">
                <div className="col pt-3 pt-md-2">
                    <Image src={Banner} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group I Prelims Test" className="img-fluid w-100"/>
                </div>
            </div>

            <div className="row d-block d-md-none">
                <div className="col pt-3 pt-md-5">
                    <Image src={MobBanner} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group I Prelims Test" className="img-fluid w-100"/>
                </div>
            </div> 
       </div>

 {/* table */}
 <section  id="courseandfees">
                <div className="container pt-xl-4" >
                    <div className="row">
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#232c6d" }}>Center</div>
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#232c6d" }}>Batch</div>
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#232c6d" }}>Starts on</div>
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#232c6d" }}>Fee</div>
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#232c6d" }}>Schedule</div>
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#232c6d" }}>Payment</div>
                        <hr/>
                    </div>
                    
                    {feestructure3.map((item,index)=>(
                        <div className={`${styles.facultyborder3} row`}>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.center}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0  pb-md-3`}>{item.mode}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.start}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Fee</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.fee}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.cont3}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2 `}>Payment</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-0`}>
                        <a href="https://admissionsv1.shankariasacademy.com/" target="_blank"> <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>
                        </div>
                        <hr/>

                        </div>
                    ))} 
                    
                </div>
	       </section> 


            <Footer />
        </>
    )
}

export default Tnpsc_gr_IV_testbatch;